import {
  createGlobalStyle,
  DefaultTheme,
  GlobalStyleComponent,
} from "styled-components";

//@ts-ignore
const GlobalStyle: GlobalStyleComponent<{}, DefaultTheme> = createGlobalStyle<{
  widgetHeight: string;
}>`
  body {
    height: ${({ widgetHeight }) => widgetHeight};
    overflow: hidden;
    margin: 0;
  }

  #bits-dashboard {
    display: flex
  }
`;

export default GlobalStyle;
